import { Box, Button, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { IS_GE_CHECKOUT } from "helpers/application"

import {
  LegalCopy,
  PlanSubtitle,
  PlanDesc,
  PlanDivider,
  PlanProductImage,
} from "./component"

const AffirmDetail = ({ paymentPrices }) => {
  return (
    <>
      <PlanSubtitle>Split Pay</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Pay over time with 4 interest-free payments{" "}
        <span className="nowrap">
          on orders {paymentPrices.affirmOrderMin} and under.
        </span>
      </PlanDesc>
      <PlanProductImage
        alt="double heart gemstone ring"
        ratio="208 / 105"
        srcSet={`${require("images/info/payment_plans/goldring.jpg")} 432w, ${require("images/info/payment_plans/goldring-x2.jpg")} 864w`}
      />

      <PlanSubtitle fontWeight="400">
        Double Heart Gemstone Ring with Accents:
      </PlanSubtitle>
      <PlanDesc fontWeight="300" width={{ desktop: "250px" }}>
        <span className="nowrap">
          {paymentPrices.splitPay} | 4 biweekly payments of{" "}
          {paymentPrices.splitPayRate}
        </span>{" "}
        with zero interest and no fees.
      </PlanDesc>
      <PlanDivider />
      <PlanSubtitle>Simple Financing</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Pay at your own pace with a choice of monthly payments on orders over{" "}
        {paymentPrices.orderMin}.
      </PlanDesc>
      <PlanProductImage
        alt="classic solitarie engagement ring"
        ratio="208 / 105"
        srcSet={`${require("images/info/payment_plans/jlux-ring.jpg")} 216w, ${require("images/info/payment_plans/jlux-ring-2x.jpg")} 432w`}
      />

      <PlanSubtitle fontWeight="400" mb={0}>
        Classic Solitaire Engagement Ring:
        <br />
        {paymentPrices.simpleFinancing} | {paymentPrices.simpleFinancingRate}
        /month
      </PlanSubtitle>
      <PlanDesc fontSize="14px" fontWeight="300">
        for 3 months at 0% APR. Rates from 0–36% APR*
      </PlanDesc>
      <PlanDivider />
      <PlanSubtitle>How It Works</PlanSubtitle>
      <PlanDesc fontWeight="300">
        Select &apos;Pay with Affirm&apos; at checkout and get a decision in
        real-time – the process is quick and easy.
      </PlanDesc>
      <Box mb={4}>
        <Box mb={3}>
          <Image
            alt="pre-qualify"
            height="63px"
            mb="13px"
            src={require("images/info/payment_plans/prequalify.png")}
            width="63px"
          />
          <PlanSubtitle mb={0}>Prequalify In Minutes</PlanSubtitle>
          <PlanDesc fontWeight="400" mb={0}>
            Complete a quick application that will not affect your credit.
          </PlanDesc>
        </Box>
        <Box mb={3}>
          <Image
            alt="know what you own"
            height="63px"
            mb="13px"
            ml="8px"
            src={require("images/info/payment_plans/know-what-you-owe.png")}
            width="78px"
          />
          <PlanSubtitle mb={0}>Know What You Owe</PlanSubtitle>
          <PlanDesc fontWeight="400" mb={0}>
            Pay over time with simple payment options and no hidden fees.
          </PlanDesc>
        </Box>
        <Box>
          <Image
            alt="worry-free"
            height="63px"
            mb="13px"
            src={require("images/info/payment_plans/worry-free.png")}
            width="66px"
          />
          <PlanSubtitle mb={0}>Shop Worry-Free</PlanSubtitle>
          <PlanDesc fontWeight="400" mb={0}>
            Wear your sparkle with confidence with our{" "}
            {IS_GE_CHECKOUT() ? "30" : "99"}
            -day return policy.
          </PlanDesc>
        </Box>
      </Box>
      <PlanSubtitle mb={6}>
        Questions?{" "}
        <Button
          as={Link}
          color="link"
          data-lc="affirm-detail"
          to="/helpdesk/search?query=Affirm"
          underline
          variant="text"
        >
          Check out our FAQs!
        </Button>
      </PlanSubtitle>
      <PlanDivider />
      <LegalCopy>
        *Rates from 0%–36% APR based on eligible purchases and creditworthiness.
        Payment options through Affirm are subject to an eligibility check and
        are provided by these lending partners:{" "}
        <a
          href="https://www.affirm.com/lenders"
          rel="noopener noreferrer"
          target="_blank"
        >
          affirm.com/lenders
        </a>
        . Options depend on your purchase amount, and a down payment may be
        required. Split payment options are available for purchases $249.99 and
        under. The estimated payment amount excludes taxes and shipping. Paid
        interest is non-refundable. Offer subject to change at any time and may
        not be available in all states. Previous purchases are ineligible. CA
        residents: Loans by Affirm Loan Services, LLC are made or arranged
        pursuant to a California Finance Lenders Law license. For licenses and{" "}
        <span className="nowrap">
          disclosures, see{" "}
          <a
            href="https://www.affirm.com/licenses"
            rel="noopener noreferrer"
            target="_blank"
          >
            affirm.com/licenses
          </a>
          .
        </span>
      </LegalCopy>
    </>
  )
}

AffirmDetail.propTypes = {
  paymentPrices: PropTypes.object,
}

export default AffirmDetail
